import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga4';

// Event tipleri
export enum EventType {
  PAGE_VIEW = 'page_view',
  SIGN_UP = 'sign_up',
  LOGIN = 'login',
  CREATE_EVENT = 'create_event',
  UPLOAD_PHOTO = 'upload_photo',
  DOWNLOAD_PHOTOS = 'download_photos',
  SHARE_EVENT = 'share_event',
  PURCHASE = 'purchase'
}

// Event parametreleri
interface EventParams {
  [key: string]: any;
}

// Event gönderme fonksiyonu
export const trackEvent = (eventType: EventType, params?: EventParams) => {
  // Facebook Pixel event
  ReactPixel.track(eventType, params);

  // Google Analytics event
  ReactGA.event(eventType, {
    ...params,
    event_category: 'engagement',
    event_label: eventType
  });
};

// Conversion event'leri
export const trackConversion = (eventType: EventType, params?: EventParams) => {
  // Facebook Pixel conversion
  ReactPixel.trackCustom(eventType, params);

  // Google Analytics conversion
  ReactGA.event(eventType, {
    ...params,
    event_category: 'conversion',
    event_label: eventType
  });
};

export const initAnalytics = () => {
  // Facebook Pixel
  ReactPixel.init('629718159879948');
  ReactPixel.pageView();

  // Google Analytics zaten gtag.js ile başlatıldı
  // Burada sadece sayfa görüntüleme olayını gönderiyoruz
  ReactGA.send('pageview');
};

// Sayfa görüntüleme
export const trackPageView = (path: string) => {
  ReactPixel.pageView();
  ReactGA.send({ hitType: "pageview", page: path });
}; 